import type { User } from "@/types";

export function isChatWidgetEnabled(user: User | null | undefined): boolean {
  if (!user?.preferences) return true;
  try {
    const preferences = JSON.parse(user.preferences) as {
      chat?: { widgetEnabled?: boolean };
    };
    return preferences.chat?.widgetEnabled ?? true;
  } catch {
    return true;
  }
}
